import React, { useContext, useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStop, faPlay } from '@fortawesome/free-solid-svg-icons'
import { checkPermissions, raiseToast } from '../../utils/helper'
import { CButton, CCard, CFormInput, CModal, CRow } from '@coreui/react'
import VideoJS from 'src/components/player/videoJS'
import ClipboardCopy from 'src/components/copyToClipboard'
import moment from 'moment-timezone'
import StreamOfflineImg from '../../../assets/stream-offline.png'
import useAxios from 'axios-hooks'
import {
  LIVE_INBOUND_API,
  LIVE_STREAM_API,
  LIVE_STREAM_START_API,
  LIVE_STREAM_STOP_API,
} from '../../utils/urls'
import { AppContext } from 'src/views/context/app'
import DeleteModal from 'src/components/DeleteModal/DeleteModal'
import { isEmpty } from 'lodash'
import { useHistory, useParams } from 'react-router-dom'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { GlobalContext } from 'src/views/context/GlobalState'
import BackIcon from '../../../assets/small-back-arrow.svg'
import InfoIcon from '../../../assets/info-icon.svg'
import RecordingsModal from './recordingsModal'
import LiveStreamStartStopModal from './liveStreamStartStopModal'
import LiveStreamProgressModal from './liveStreamProgressModal'
import Timer from 'src/components/timer/timer'
import { useInterval } from 'src/hooks/useInterval'
import StopProgressModal from './stopProgressModal'

let HLS_URL = ''

const LiveStreamDetail = () => {
  const playerRef = React.useRef(null)
  const history = useHistory()
  const { liveId } = useParams()
  const { setLoader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)

  const [data, setData] = useState({})
  const [recordingModal, setRecordingModal] = useState(false)
  const [startStopModal, setStartStopModal] = useState('')
  const [progressModal, setProgressModal] = useState(false)
  const [stopProgressModal, setStopProgressModal] = useState(false)
  const [frameSize, setFrameSize] = useState('N/A')
  const [deleteModal, setDeleteModal] = useState(false)
  const [isPlayerPlaying, setIsPlayerPlaying] = useState(false)
  const [liveSessionsInfo, setLiveSessionsInfo] = useState({})
  const isUpdateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.LIVE.UPDATE,
  )

  const isStreamStarted =
    data?.in_progress &&
    !isEmpty(data?.live_sessions) &&
    data?.live_sessions[data?.live_sessions.length - 1]?.server_data?.status === 'LIVE'

  let liveDataInterval

  const getLiveData = async (isFirst = false) => {
    liveDataInterval =
      !liveDataInterval &&
      setInterval(async () => {
        console.log('intervalllll')
        let livestreamRes = await liveStreamListCall()
        const tempData = livestreamRes?.data?.data
        console.log('tempData', tempData)
        if (clearIntervalFlag(tempData)) {
          clearInterval(liveDataInterval)
        }
      }, 10000)

    if (isFirst) {
      clearInterval(liveDataInterval)
      await liveStreamListCall()
    }

    if (clearIntervalFlag(data)) clearInterval(liveDataInterval)
  }

  useEffect(() => {
    getLiveData(isEmpty(data) ? true : false)

    return () => clearInterval(liveDataInterval)
  }, [data])

  useEffect(() => {
    playerAction()
  }, [data])

  useEffect(() => {
    if (
      data.in_progress &&
      !isEmpty(data?.live_sessions) &&
      data?.live_sessions[data?.live_sessions.length - 1]?.server_data?.status === 'INITIATED'
    ) {
      setProgressModal(true)
    }

    if (
      !data.in_progress &&
      !isEmpty(data?.live_sessions) &&
      data?.live_sessions[data?.live_sessions.length - 1]?.server_data?.status === 'LIVE'
    ) {
      setStopProgressModal(true)
    }
  }, [data])

  const [{ data: liveStreamList, loading: liveStreamLoading }, liveStreamListCall] = useAxios(
    {
      url: LIVE_STREAM_API,
      method: 'get',
      params: {
        stream_id: liveId,
      },
    },
    { manual: true },
  )

  const [{ data: liveInboundData }, liveInboundCall] = useAxios(
    {
      url: LIVE_INBOUND_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: deleteRecordingData, loading: deleteRecordingLoading }, deleteRecordingCall] =
    useAxios(
      {
        url: `${LIVE_STREAM_API}/recording`,
        method: 'delete',
      },
      { manual: true },
    )

  const [
    { data: downloadRecordingdata, loading: downloadRecordingLoading },
    downloadRecordingCall,
  ] = useAxios(
    {
      url: `${LIVE_STREAM_API}/download?stream_id=${data._id}`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: startLiveStreamData, loading: liveStreamStartLoading }, startLiveStreamCall] =
    useAxios(
      {
        url: LIVE_STREAM_START_API,
        method: 'put',
      },
      { manual: true },
    )

  const [{ data: stopLiveStreamData, loading: liveStreamStopLoading }, stopLiveStreamCall] =
    useAxios(
      {
        url: LIVE_STREAM_STOP_API,
        method: 'put',
      },
      { manual: true },
    )

  const clearIntervalFlag = (info) => {
    let flag = false

    if (isEmpty(info?.live_sessions)) {
      flag = true
    }

    if (!isEmpty(info?.live_sessions)) {
      let status = info?.live_sessions[info?.live_sessions.length - 1]?.server_data?.status

      flag =
        status === 'TERMINATED' || (info.in_progress && status === 'LIVE') || status === 'FAILED'
    }
    return flag
  }

  useEffect(() => {
    setLoader(
      downloadRecordingLoading ||
        deleteRecordingLoading ||
        liveStreamLoading ||
        liveStreamStartLoading ||
        liveStreamStopLoading,
    )
  }, [
    downloadRecordingLoading,
    deleteRecordingLoading,
    liveStreamStartLoading,
    liveStreamStopLoading,
    liveStreamLoading,
  ])

  useEffect(() => {
    if (liveStreamList && liveStreamList.success) {
      setData(liveStreamList.data)
      HLS_URL = liveStreamList?.data?.hls_url
    }
  }, [liveStreamList])

  useEffect(() => {
    if (liveInboundData && liveInboundData?.success) {
      setFrameSize(liveInboundData?.data)
    }
  }, [liveInboundData])

  useEffect(() => {
    if (stopLiveStreamData && stopLiveStreamData.success) {
      getLiveData(true)
      setStartStopModal('')
      setStopProgressModal(true)
      setIsPlayerPlaying(false)
    }
  }, [stopLiveStreamData])

  useEffect(() => {
    if (startLiveStreamData && startLiveStreamData.success) {
      getLiveData(true)
      setStartStopModal('')
      setProgressModal(true)
    }
  }, [startLiveStreamData])

  useEffect(() => {
    if (deleteRecordingData && deleteRecordingData.success) {
      getLiveData(true)
      raiseToast('success', 'Recording Deleted Successfully!')
    }
  }, [deleteRecordingData])

  useEffect(() => {
    if (downloadRecordingdata && downloadRecordingdata.success) {
      window.open(downloadRecordingdata.data.url, '_blank')
    }
  }, [downloadRecordingdata])

  const startLiveStream = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    startLiveStreamCall({
      params: {
        stream_id: info._id,
      },
    })
  }

  const stopLiveStream = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    stopLiveStreamCall({
      params: {
        stream_id: info._id,
      },
    })
  }

  const playerAction = () => {
    if (!playerRef.current) {
      return
    }
    if (
      data?.in_progress &&
      !isEmpty(data?.live_sessions) &&
      data?.live_sessions[data?.live_sessions.length - 1]?.server_data?.status === 'LIVE'
    ) {
      playerRef.current.reset()
      playerRef.current.src([
        {
          src: data?.hls_url,
          type: 'application/x-mpegURL',
        },
      ])
    } else {
      playerRef.current.reset()
      playerRef.current.src([])
      playerRef.current.poster(StreamOfflineImg)
      setFrameSize('N/A')
    }
  }

  const videoJsOptions = {
    // lookup the options in the docs for more options
    controls: false,
    responsive: true,
    muted: true,
    loadingSpinner: true,
    autoplay: true,
    liveui: true,
    poster: StreamOfflineImg,
    suppressNotSupportedError: true,
    errorDisplay: false,
    sources: [],
  }

  const handlePlayerReady = (player) => {
    playerRef.current = player

    // you can handle player events here
    player.on('waiting', () => {
      console.log('player is waiting')
    })

    player.on('canplay', () => {
      console.log('player is canplay')
      liveInboundCall({
        params: {
          url: HLS_URL,
        },
      })
      setIsPlayerPlaying(true)
    })

    player.on('dispose', () => {
      console.log('player will dispose')
      setFrameSize('N/A')
    })

    player.on('error', () => {
      setIsPlayerPlaying(false)
    })
  }

  useInterval(
    async () => {
      if (!isPlayerPlaying && isStreamStarted) {
        console.log('retryyyy')
        setData((data) => ({ ...data }))
      }
    },
    !isPlayerPlaying && isStreamStarted ? 5000 : null,
  )

  const handleDownload = (info) => {
    downloadRecordingCall({
      params: {
        session_id: info.session_id,
      },
    })
  }

  const handleDelete = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setLiveSessionsInfo(info)
    setDeleteModal(true)
  }

  const handleDeleteRecording = () => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }

    deleteRecordingCall({
      params: {
        stream_id: data._id,
        session_id: liveSessionsInfo.session_id,
      },
    })
    setLiveSessionsInfo({})
    setDeleteModal(false)
  }

  const statsFieldStyle = { width: '40%', fontWeight: 'bold', fontSize: '0.729vw' }
  const statsStatusStyle = { width: '59%', fontSize: '0.729vw' }
  return (
    <>
      <div className="d-flex align-items-center justify-content-between w-100 mt-2">
        <h4 className="px-0">Live Stream: {data.name}</h4>
        <CButton
          className="text-white px- py-1"
          onClick={() => {
            history.push('/live-stream')
          }}
          style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
        >
          <img src={BackIcon} alt="BackIcon" className="mr-2" />
          Back
        </CButton>
      </div>
      <CCard className="mt-2 px-4 py-2">
        <div
          style={{ width: '62.75%' }}
          className="d-flex align-items-center justify-content-between mt-2"
        >
          <p className="mb-0" style={{ fontSize: '0.9vw', fontWeight: '550' }}>
            Video Preview
          </p>
          <div className="d-flex align-items-center">
            {data.in_progress ? (
              !isEmpty(data?.live_sessions) &&
              data?.live_sessions[data?.live_sessions.length - 1]?.server_data?.status ===
                'INITIATED' ? (
                <>
                  <CButton className="text-white" color="success">
                    Please wait ...
                  </CButton>
                </>
              ) : (
                <CButton
                  className="text-white"
                  color="danger"
                  onClick={() => setStartStopModal('STOP')}
                  disabled={!isUpdateAllowed}
                >
                  <FontAwesomeIcon icon={faStop} style={{ marginRight: '0.4rem' }} />
                  Stop Live Stream
                </CButton>
              )
            ) : !isEmpty(data?.live_sessions) &&
              data?.live_sessions[data?.live_sessions.length - 1]?.server_data?.status ===
                'LIVE' ? (
              <>
                <CButton className="text-white mx-2" color="danger">
                  Please wait ...
                </CButton>
              </>
            ) : (
              <CButton
                className="text-white"
                color="success"
                onClick={() => setStartStopModal('START')}
                disabled={!isUpdateAllowed}
              >
                <FontAwesomeIcon icon={faPlay} style={{ marginRight: '0.4rem' }} />
                Start Live Stream
              </CButton>
            )}
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div style={{ width: '62.75%' }} className="mt-2">
            <div style={{ aspectRatio: '935 / 526' }} className="w-100 mt-2">
              <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
            </div>
            <div
              className="w-100 px-2 d-flex justify-content-between py-1"
              style={{
                fontSize: '0.9vw',
                fontWeight: '500',
                background: isPlayerPlaying ? '#0b8d1d' : 'black',
              }}
            >
              <span className="text-white d-flex align-items-center">
                {isStreamStarted && (
                  <div
                    style={{ width: '16px', height: '16px', background: '#d80000' }}
                    className="rounded-full mr-2"
                  />
                )}
                {isStreamStarted ? 'LIVE STREAM RUNNING.' : 'LIVE STREAM STOPPED'}
                {isStreamStarted && !isPlayerPlaying ? (
                  <span className="mx-4">{'NO VIDEO DETECTED.'}</span>
                ) : (
                  ''
                )}
              </span>
              {!isStreamStarted && (
                <span style={{ color: '#09e9e9' }}>
                  Before you can connect to your video source, you have to start the live stream.
                </span>
              )}
              {isStreamStarted && (
                <span style={{ color: isPlayerPlaying ? '#fff' : '#09e9e9' }} className=" d-flex">
                  <span>
                    {moment
                      .unix(data?.live_sessions[data?.live_sessions.length - 1].start)
                      .format('DD MMMM YYYY')}
                  </span>
                  <span className="mx-3">
                    {moment
                      .unix(data?.live_sessions[data?.live_sessions.length - 1].start)
                      .format('hh.mm A')}
                  </span>
                  <div className="">
                    <Timer
                      deadline={moment.unix(
                        data?.live_sessions[data?.live_sessions.length - 1].start,
                      )}
                    />
                  </div>
                </span>
              )}
            </div>
          </div>
          <div style={{ width: '32.35%' }} className=" mt-2">
            <p className="mb-1" style={{ fontSize: '0.9vw', fontWeight: '550' }}>
              STATISTICS
            </p>
            <hr className="w-100 mt-1 mb-1" />
            <div className="d-flex justify-content-between mt-3">
              <div style={statsFieldStyle}>Inbound :</div>
              <div style={statsStatusStyle}>
                {frameSize && frameSize !== 'N/A' ? 'Connected' : 'N/A'}
              </div>
            </div>
            <div className="d-flex justify-content-between mt-3">
              <div style={statsFieldStyle}>Outbound :</div>
              <div style={statsStatusStyle}>{'N/A'}</div>
            </div>
            <div className="d-flex justify-content-between mt-3">
              <div style={statsFieldStyle}>Frame Size :</div>
              <div style={statsStatusStyle}>{frameSize}</div>
            </div>
            <div className="d-flex justify-content-between mt-3">
              <div style={statsFieldStyle}>Created Date :</div>
              <div style={statsStatusStyle}>
                {moment.utc(data.created_date).format('DD.MM.YYYY')}
              </div>
            </div>
            <div className="d-flex justify-content-between mt-3">
              <div style={statsFieldStyle}>Description :</div>
              <div style={statsStatusStyle}>{data.description}</div>
            </div>
            <div className="d-flex justify-content-between mt-3">
              <div style={statsFieldStyle}>Recording :</div>
              <div style={statsStatusStyle}>
                {data.to_record ? 'Enabled' : 'Disabled'}
                <span
                  style={{ color: '#1592e6' }}
                  onClick={() => setRecordingModal(true)}
                  className="underline cursor-pointer mx-4"
                >
                  Show Files
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-3">
              <div style={statsFieldStyle}>Total Unique Viewers :</div>
              <div style={statsStatusStyle}>{'N/A'}</div>
            </div>
            <div className="d-flex justify-content-between mt-3">
              <div style={statsFieldStyle}>Current Unique Viewers :</div>
              <div style={statsStatusStyle}>{'N/A'}</div>
            </div>
          </div>
        </div>
        <CRow className="mt-4">
          <div className="d-flex align-items-center mb-2">
            <p className="mb-0" style={{ fontSize: '0.9vw', fontWeight: '550' }}>
              STREAM INFORMATION
            </p>
            <img
              src={InfoIcon}
              title={`Configure your camera or video source with this information so it knows how to connect to OTTDock Video.`}
              alt="InfoIcon"
              className="mx-3 cursor-pointer"
            />
          </div>
          <div className="mt-1 mb-2">
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div
                style={{ width: '16%', fontSize: '0.73vw', fontWeight: '550', color: '#6a6a6a' }}
              >
                Primary Server (RTMP)
              </div>
              <div style={{ width: '83%' }}>
                <ClipboardCopy inputFontSize={'0.73vw'} copyText={data?.rtmp_url} />
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div
                style={{ width: '16%', fontSize: '0.73vw', fontWeight: '550', color: '#6a6a6a' }}
              >
                Stream Key
              </div>
              <div style={{ width: '83%' }}>
                <ClipboardCopy inputFontSize={'0.73vw'} copyText={data?.stream_key} />
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div
                style={{ width: '16%', fontSize: '0.73vw', fontWeight: '550', color: '#6a6a6a' }}
              >
                HLS
              </div>
              <div style={{ width: '83%' }}>
                <ClipboardCopy inputFontSize={'0.73vw'} copyText={data?.hls_url} />
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div
                style={{ width: '16%', fontSize: '0.73vw', fontWeight: '550', color: '#6a6a6a' }}
              >
                Host Port
              </div>
              <div style={{ width: '83%' }}>
                <CFormInput
                  style={{ fontSize: '0.73vw' }}
                  readOnly
                  value={'1935'}
                  className=" btn-focus-none"
                />
              </div>
            </div>
          </div>
        </CRow>
      </CCard>
      {recordingModal && (
        <RecordingsModal
          data={data.live_sessions}
          onClose={() => setRecordingModal(false)}
          onDelete={handleDelete}
          onDownload={handleDownload}
        />
      )}
      {deleteModal && (
        <DeleteModal
          openModal={deleteModal}
          title={`Are you sure you want to delete this Recording?`}
          confirmButtonText={`Yes`}
          onCancel={() => {
            setLiveSessionsInfo({})
            setDeleteModal(false)
          }}
          onConfirm={handleDeleteRecording}
        />
      )}
      {startStopModal && (
        <LiveStreamStartStopModal
          type={startStopModal}
          onCancel={() => setStartStopModal('')}
          onStop={() => stopLiveStream(data)}
          onStart={() => startLiveStream(data)}
          loading={liveStreamStartLoading || liveStreamStopLoading}
        />
      )}
      {progressModal && (
        <LiveStreamProgressModal
          name={data.name}
          liveStreamData={
            !isEmpty(data?.live_sessions) ? data?.live_sessions[data?.live_sessions.length - 1] : {}
          }
          handleClose={() => {
            setProgressModal(false)
          }}
        />
      )}
      {stopProgressModal && (
        <StopProgressModal
          name={data.name}
          liveStreamData={
            !isEmpty(data?.live_sessions) ? data?.live_sessions[data?.live_sessions.length - 1] : {}
          }
          handleClose={() => {
            setStopProgressModal(false)
          }}
        />
      )}
    </>
  )
}

export default LiveStreamDetail
